/** Typography tokens — verbatim from source --fs-* / --fw-* and font families. */

export const fontFamily = {
  sans: '"IBM Plex Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, Menlo, monospace',
} as const;

export const fontSize = {
  xs: 11,
  sm: 12,
  md: 13,
  lg: 15,
  xl: 18,
  xxl: 22,
  xxxl: 28,
} as const;

export const fontWeight = {
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
} as const;

export type FontSize = typeof fontSize;
export type FontWeight = typeof fontWeight;
